import axios from "axios";
import appConfig from "@/config/app";
import localStore from "@/utils/localStore";
import { userTypes } from "@/middleware/pageAccessManager";

const appUrl = appConfig.BK_APP_URL;
const adminUrl = appConfig.BK_ADMIN_URL;
const dealerUrl = appConfig.BK_DEALER_URL;
const accountUrl = appConfig.BK_ACCOUNT_URL;
export const $axios = axios.create({
  baseURL: appUrl,
  timeout: 0,
});
export const $superAccountAxios = axios.create({
  baseURL: accountUrl,
  timeout: 0,
});

export const $superDealerAxios = axios.create({
  baseURL: dealerUrl,
  timeout: 0,
});

export const $superAdminAxios = axios.create({
  baseURL: adminUrl,
  timeout: 0,
});

const userType = localStore.getItem(`curr-user-type`);
const userId = localStore.getItem(`${userType}-id`);
if (userType && userId) {
  const userInfo = localStore.getItem(`${userType}-${userId}`);
  if (userInfo && userInfo.access_token && userInfo.refresh_token) {
    if (userType === userTypes.super_admin) {
      $superAdminAxios.defaults.headers.common.Authorization =
        userInfo.access_token;
    } else if (userType === userTypes.dealer) {
      $superDealerAxios.defaults.headers.common.Authorization =
        userInfo.access_token;
    } else if (userType === userTypes.account_manager) {
      $superAccountAxios.defaults.headers.common.Authorization =
        userInfo.access_token;
    } else {
      $axios.defaults.headers.common.Authorization = userInfo.access_token;
    }
  }
}

export default { $axios, $superDealerAxios, $superAccountAxios, $superAdminAxios };
